/**
 * Adapted from PlayCanvas Engine's gsplat-alloc-id.js at
 * d88289fb0c17be76ec4159974faf0d07d3582a6b (MIT License).
 */
class GSplatAllocIdGenerator {
  private counter = 0

  get(): number {
    return this.counter++
  }
}

/** Placement 与 Octree interval 共用的进程内单调 allocation id 空间。 */
export const GSPLAT_ALLOC_IDS = new GSplatAllocIdGenerator()
